import React, { useState, useEffect } from "react";

const TermsAndConditions = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isSmallMobile, setIsSmallMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallMobile(window.innerWidth <= 480);
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Check initial size
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const containerStyle = {
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "1.8",
    color: "#2c2c2c",
    maxWidth: "1200px",
    margin: "0 auto",
    padding: isSmallMobile ? "8px" : isMobile ? "15px" : "40px",
    backgroundColor: "#ffffff",
    minHeight: "100vh",
  };

  const contentStyle = {
    backgroundColor: "white",
    padding: isSmallMobile ? "15px" : isMobile ? "25px" : "60px",
    border: "1px solid #e0e0e0",
    boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <div
          style={{
            textAlign: "center",
            padding: "20px 0",
            marginBottom: "20px",
          }}
        >
          <img
            src="/KinShieldIcon.png"
            alt="KinShield Logo"
            draggable={false}
            onContextMenu={(e) => e.preventDefault()}
            style={{
              maxWidth: "100px",
              height: "auto",
              mixBlendMode: "multiply",
              borderRadius: "15px",
              boxShadow: "0 6px 16px rgba(0, 0, 0, 0.3)",
              WebkitUserDrag: "none",
              userSelect: "none",
            }}
          />
        </div>
        <style>
          {`
            .terms-conditions ul,
            .terms-conditions ol {
              text-align: left !important;
              padding-left: 30px !important;
              margin: 20px 0 !important;
            }
            .terms-conditions li {
              text-align: left !important;
              margin: 12px 0 !important;
              line-height: 1.6;
            }
            .terms-conditions h1, .terms-conditions h2, .terms-conditions h3, .terms-conditions h4 {
              text-align: left !important;
              font-family: Arial, Helvetica, sans-serif;
              font-weight: 400;
              margin-top: 40px;
              margin-bottom: 20px;
            }
            .terms-conditions h1 {
              font-size: 2.2em;
              margin-bottom: 30px;
              border-bottom: 2px solid #333;
              padding-bottom: 15px;
            }
            .terms-conditions h2 {
              font-size: 1.5em;
              margin-top: 50px;
              border-bottom: 1px solid #ccc;
              padding-bottom: 10px;
            }
            .terms-conditions h3 {
              font-size: 1.2em;
              margin-top: 35px;
            }
            .terms-conditions h4 {
              font-size: 1.1em;
              margin-top: 25px;
            }
            .terms-conditions p {
              margin: 16px 0;
              text-align: justify;
            }
            .terms-conditions table {
              border-collapse: collapse;
              width: 100%;
              margin: 25px 0;
            }
            .terms-conditions th {
              background-color: #f5f5f5;
              color: #333;
              font-family: Arial, Helvetica, sans-serif;
              font-weight: 400;
              text-align: left;
              padding: 15px;
              border: 1px solid #ddd;
            }
            .terms-conditions td {
              padding: 12px 15px;
              border: 1px solid #ddd;
              vertical-align: top;
            }
            .terms-conditions tr:nth-child(even) {
              background-color: #fafafa;
            }
            
            /* Mobile Responsive Styles */
            @media (max-width: 768px) {
              .terms-conditions h1 {
                font-size: 1.8em !important;
                margin-top: 20px !important;
                margin-bottom: 15px !important;
                padding-bottom: 10px !important;
              }
              .terms-conditions h2 {
                font-size: 1.3em !important;
                margin-top: 25px !important;
                margin-bottom: 10px !important;
                padding-bottom: 8px !important;
              }
              .terms-conditions h3 {
                font-size: 1.1em !important;
                margin-top: 20px !important;
                margin-bottom: 8px !important;
              }
              .terms-conditions h4 {
                font-size: 1.05em !important;
                margin-top: 15px !important;
                margin-bottom: 8px !important;
              }
              .terms-conditions p {
                margin: 8px 0 !important;
              }
              .terms-conditions ul,
              .terms-conditions ol {
                padding-left: 20px !important;
                margin: 10px 0 !important;
              }
              .terms-conditions li {
                margin: 6px 0 !important;
              }
              .terms-conditions table {
                margin: 15px 0 !important;
                font-size: 0.9em;
              }
              .terms-conditions th,
              .terms-conditions td {
                padding: 8px 6px !important;
              }
            }
            
            @media (max-width: 480px) {
              .terms-conditions h1 {
                font-size: 1.6em !important;
                margin-top: 15px !important;
                margin-bottom: 12px !important;
              }
              .terms-conditions h2 {
                font-size: 1.2em !important;
                margin-top: 20px !important;
                margin-bottom: 8px !important;
              }
              .terms-conditions h3 {
                font-size: 1.05em !important;
                margin-top: 15px !important;
                margin-bottom: 6px !important;
              }
              .terms-conditions h4 {
                font-size: 1em !important;
                margin-top: 12px !important;
                margin-bottom: 6px !important;
              }
              .terms-conditions p {
                margin: 6px 0 !important;
              }
              .terms-conditions ul,
              .terms-conditions ol {
                padding-left: 15px !important;
                margin: 8px 0 !important;
              }
              .terms-conditions li {
                margin: 4px 0 !important;
              }
              .terms-conditions table {
                margin: 10px 0 !important;
                font-size: 0.85em;
              }
              .terms-conditions th,
              .terms-conditions td {
                padding: 6px 4px !important;
              }
            }
          `}
        </style>
        <div className="terms-conditions">
          <h1>Terms and Conditions for KinShield</h1>

          <div
            style={{
              backgroundColor: "#f8f8f8",
              padding: "25px",
              border: "1px solid #ddd",
              marginBottom: "40px",
            }}
          >
            <p style={{ margin: "0 0 10px 0" }}>
              <strong>Effective Date:</strong> August 1, 2025
            </p>
            <p style={{ margin: "0" }}>
              <strong>Last Updated:</strong> June 26, 2026
            </p>
          </div>

          <div style={{ marginBottom: "40px" }}>
            <h2>Table of Contents</h2>
            <ol
              style={{
                lineHeight: "1.8",
                textAlign: "left",
                paddingLeft: "30px",
              }}
            >
              <li>
                <a
                  href="#introduction"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Introduction and Acceptance of Terms
                </a>
              </li>
              <li>
                <a
                  href="#educational-purpose"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Educational Purpose and Simulation Safety
                </a>
              </li>
              <li>
                <a
                  href="#eligibility"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Eligibility and Account Requirements
                </a>
              </li>
              <li>
                <a
                  href="#service-description"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Service Description and Availability
                </a>
              </li>
              <li>
                <a
                  href="#subscription"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Subscription Terms and Billing
                </a>
              </li>
              <li>
                <a
                  href="#user-responsibilities"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  User Responsibilities and Acceptable Use
                </a>
              </li>
              <li>
                <a
                  href="#data-privacy"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Data Privacy and Protection
                </a>
              </li>
              <li>
                <a
                  href="#intellectual-property"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Intellectual Property Rights
                </a>
              </li>
              <li>
                <a
                  href="#account-termination"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Account Termination
                </a>
              </li>
              <li>
                <a
                  href="#disclaimers"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Disclaimers and Limitations of Liability
                </a>
              </li>
              <li>
                <a
                  href="#privacy-compliance"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Privacy and Compliance
                </a>
              </li>
              <li>
                <a
                  href="#dispute-resolution"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Dispute Resolution and Governing Law
                </a>
              </li>
              <li>
                <a
                  href="#general-provisions"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  General Provisions
                </a>
              </li>
              <li>
                <a
                  href="#acknowledgment"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Acknowledgment and Acceptance
                </a>
              </li>
              <li>
                <a
                  href="#ai-technology"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Artificial Intelligence Technology Disclosure
                </a>
              </li>
              <li>
                <a
                  href="#no-professional-advice"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  No Professional Advice or Law Enforcement
                </a>
              </li>
              <li>
                <a
                  href="#indemnification"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Indemnification
                </a>
              </li>
              <li>
                <a
                  href="#corporate-accounts"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Corporate and Organizational Accounts
                </a>
              </li>
              <li>
                <a
                  href="#submitted-content"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  User-Submitted Content, Warranties, and Prohibited Content
                </a>
              </li>
            </ol>
          </div>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="introduction" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              1. Introduction and Acceptance of Terms
            </h2>

            <p>
              Welcome to KinShield, a cybersecurity training platform operated
              by Reliable IT Associates, LLC ("Company," "we," "us," or "our").
              These Terms and Conditions ("Terms") govern your use of the
              KinShield service ("Service") and constitute a legally binding
              agreement between you ("User," "you," or "your") and Reliable IT
              Associates, LLC.
            </p>

            <div
              style={{
                backgroundColor: "#f8f8f8",
                border: "1px solid #ddd",

                padding: "15px",
                margin: "20px 0",
              }}
            >
              <strong style={{}}>
                By accessing or using KinShield, you acknowledge that you have
                read, understood, and agree to be bound by these Terms.
              </strong>{" "}
              If you do not agree to these Terms, you may not access or use the
              Service.
            </div>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              Key Service Overview
            </h3>
            <p>KinShield provides:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                AI-powered cybersecurity simulations (phishing, vishing, social
                engineering)
              </li>
              <li>
                Personalized training modules, quizzes, badges, and certificates
              </li>
              <li>
                Real-time performance tracking, risk scoring, and safety score
                analytics
              </li>
              <li>
                Family/group management and role-based access control features
              </li>
              <li>AI-powered email analysis and scam detection tools</li>
              <li>AI-powered SMS/text message scam analysis and detection</li>
              <li>
                AI-powered image and screenshot analysis using computer vision
              </li>
              <li>AI-powered social media content scam analysis</li>
              <li>URL safety analysis and phishing detection</li>
              <li>Phone number scam verification and risk scoring</li>
              <li>
                AI-powered Digital Personal Guard (DPG) chatbot for scam
                consultation
              </li>
              <li>Fraud detection pipeline with document analysis and OCR</li>
              <li>Real-time alerts and intelligence hub</li>
              <li>Security reports and risk assessments</li>
              <li>Blog content and educational resources</li>
              <li>Adaptive learning progression systems</li>
              <li>Real-time WebSocket notifications</li>
              <li>Newsletter communications</li>
            </ul>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="educational-purpose" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              2. Educational Purpose and Simulation Safety
            </h2>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              2.1 Educational Nature of Service
            </h3>
            <div
              style={{
                backgroundColor: "#f8f8f8",
                border: "1px solid #ddd",

                padding: "15px",
                margin: "20px 0",
              }}
            >
              <strong style={{}}>IMPORTANT:</strong> All simulations, training
              exercises, and security scenarios provided through KinShield are{" "}
              <strong>
                educational tools designed for cybersecurity awareness training
                only
              </strong>
              . These simulations are:
              <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
                <li>
                  Safe, controlled, and conducted in a secure testing
                  environment
                </li>
                <li>Not actual security threats or real cyberattacks</li>
                <li>
                  Designed to improve your cybersecurity knowledge and awareness
                </li>
                <li>
                  Never intended to cause harm, distress, or actual security
                  vulnerabilities
                </li>
              </ul>
            </div>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              2.2 Simulation Safety Protocols
            </h3>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                All phishing and social engineering simulations are clearly
                marked as training exercises
              </li>
              <li>
                No actual malware, viruses, or harmful code is ever transmitted
              </li>
              <li>
                Simulated scenarios cannot access, modify, or compromise your
                actual systems or data
              </li>
              <li>
                Training exercises are contained within our secure platform
                environment
              </li>
              <li>
                You will receive clear notifications when participating in
                training simulations
              </li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              2.3 Disclaimer of Real Threats
            </h3>
            <p>
              KinShield simulations are <strong>NOT</strong> real cybersecurity
              threats. If you encounter actual phishing attempts, malware, or
              security threats outside of our platform, please report them to
              appropriate authorities and do not assume they are part of our
              training program.
            </p>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="ai-technology" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              15. Artificial Intelligence Technology Disclosure
            </h2>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              15.1 Use of AI Technology
            </h3>
            <div
              style={{
                backgroundColor: "#f8f8f8",
                border: "1px solid #ddd",
                padding: "15px",
                margin: "20px 0",
              }}
            >
              <strong style={{}}>IMPORTANT AI DISCLOSURE:</strong>
              <p>
                KinShield extensively uses artificial intelligence ("AI") and
                machine learning technologies, including but not limited to
                large language models (LLMs), computer vision models, natural
                language processing (NLP), and automated analysis engines, to
                provide its Services. These AI technologies are provided by
                third-party AI service providers and are integrated into the
                following features:
              </p>
              <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
                <li>
                  Email, SMS/text, and social media scam detection and analysis
                </li>
                <li>Image and screenshot analysis using AI vision models</li>
                <li>URL safety and phishing detection assessments</li>
                <li>Phone number risk scoring and verification</li>
                <li>Fraud detection pipeline and document analysis</li>
                <li>Digital Personal Guard (DPG) chatbot consultations</li>
                <li>Simulation content generation for training exercises</li>
                <li>Blog and educational content generation</li>
                <li>Risk scoring and safety score calculations</li>
                <li>
                  Personally Identifiable Information (PII) detection and
                  redaction
                </li>
                <li>
                  Optical Character Recognition (OCR) for document text
                  extraction
                </li>
                <li>QR code detection and analysis in images</li>
                <li>Alert intelligence analysis</li>
              </ul>
            </div>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              15.2 AI Limitations and Accuracy
            </h3>
            <div
              style={{
                backgroundColor: "#f8f8f8",
                border: "1px solid #ddd",
                padding: "15px",
                margin: "20px 0",
              }}
            >
              <strong style={{}}>
                YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT:
              </strong>
              <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
                <li>
                  <strong>AI Can Make Mistakes:</strong> AI-generated analyses,
                  assessments, and recommendations may contain errors,
                  inaccuracies, or omissions. AI technology is inherently
                  probabilistic and does not guarantee correct or complete
                  results.
                </li>
                <li>
                  <strong>AI May Use Outdated Information:</strong> AI models
                  are trained on data up to a certain date and may not reflect
                  the most current scam tactics, techniques, legal requirements,
                  or real-world developments. Scam methodologies evolve
                  continuously and AI models may not recognize the latest
                  threats.
                </li>
                <li>
                  <strong>
                    AI May Produce False Positives or False Negatives:
                  </strong>{" "}
                  AI analysis may incorrectly flag legitimate communications as
                  scams (false positives) or fail to identify actual scam
                  attempts (false negatives). Users should not rely solely on AI
                  analysis to determine the legitimacy of any communication.
                </li>
                <li>
                  <strong>AI Hallucinations:</strong> AI models may generate
                  plausible-sounding but factually incorrect information,
                  fabricated details, or misleading conclusions. This
                  phenomenon, known as "hallucination," is an inherent
                  limitation of current AI technology.
                </li>
                <li>
                  <strong>No Guarantee of Detection:</strong> KinShield does not
                  guarantee that its AI systems will detect all scams, fraud
                  attempts, phishing schemes, or malicious communications. Some
                  sophisticated scam attempts may evade detection.
                </li>
                <li>
                  <strong>AI Is a Tool, Not a Substitute for Judgment:</strong>{" "}
                  AI-generated results are intended to assist and educate users,
                  not to replace the user's own critical thinking, judgment, or
                  independent verification. Users are ultimately responsible for
                  their own decisions and actions.
                </li>
                <li>
                  <strong>Third-Party AI Providers:</strong> KinShield utilizes
                  third-party AI service providers to process and analyze
                  user-submitted content. These providers have their own terms
                  of service, privacy policies, and limitations. KinShield does
                  not control and is not responsible for the performance,
                  accuracy, or availability of third-party AI services.
                </li>
                <li>
                  <strong>Continuous Improvement:</strong> We continuously work
                  to improve the accuracy and reliability of our AI systems, but
                  perfection is not achievable with current AI technology and
                  should not be expected.
                </li>
              </ul>
            </div>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              15.3 AI-Generated Content
            </h3>
            <p>
              Certain content on the KinShield platform, including but not
              limited to scam analysis results, training simulations,
              educational materials, blog posts, alert intelligence, and chatbot
              responses, may be generated or assisted by AI. Such content is
              provided for educational and informational purposes only and
              should not be treated as definitive, authoritative, or
              professional advice of any kind. Users should independently verify
              any AI-generated information before acting upon it.
            </p>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              15.4 User Responsibility Regarding AI Output
            </h3>
            <p>
              By using KinShield's AI-powered features, you agree that you will
              not hold KinShield, Reliable IT Associates, LLC, or its officers,
              directors, employees, agents, or affiliates responsible or liable
              for any actions you take or fail to take based on AI-generated
              analyses, recommendations, or assessments. You acknowledge that
              the ultimate responsibility for protecting yourself from scams and
              fraud rests with you.
            </p>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="no-professional-advice" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              16. No Professional Advice or Law Enforcement
            </h2>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              16.1 Not Law Enforcement
            </h3>
            <div
              style={{
                backgroundColor: "#f8f8f8",
                border: "1px solid #ddd",
                padding: "15px",
                margin: "20px 0",
              }}
            >
              <strong style={{}}>
                KINSHIELD IS NOT A LAW ENFORCEMENT AGENCY, GOVERNMENT ENTITY, OR
                REGULATORY BODY.
              </strong>{" "}
              KinShield does not have the authority, ability, or obligation to
              investigate crimes, apprehend criminals, enforce laws, or take any
              law enforcement action. KinShield does not directly intervene in
              or prevent ongoing scam attempts or fraud schemes. If you believe
              you are the victim of a crime, including fraud or identity theft,
              you should contact local law enforcement, the Federal Trade
              Commission (FTC), or other appropriate governmental authorities
              immediately.
            </div>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              16.2 Not Legal Advice
            </h3>
            <p>
              KinShield does not provide legal advice, legal counsel, or legal
              representation of any kind. No information, analysis,
              recommendation, or communication provided through the Service
              constitutes legal advice or creates an attorney-client
              relationship. If you require legal advice regarding fraud, scams,
              identity theft, or any other matter, you should consult a
              qualified attorney licensed in your jurisdiction.
            </p>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              16.3 Not Financial Advice
            </h3>
            <p>
              KinShield does not provide financial advice, investment advice,
              tax advice, or financial planning services. No information
              provided through the Service should be construed as financial,
              investment, or tax advice. If you need financial guidance, you
              should consult a qualified financial advisor, accountant, or other
              appropriate financial professional.
            </p>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              16.4 Not Personal or Medical Advice
            </h3>
            <p>
              KinShield does not provide personal counseling, psychological
              advice, or medical advice of any kind. While we acknowledge that
              encountering scams and fraud can cause emotional distress, the
              Service is not a substitute for professional counseling or mental
              health services.
            </p>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              16.5 Educational Purpose Only
            </h3>
            <div
              style={{
                backgroundColor: "#f8f8f8",
                border: "1px solid #ddd",
                padding: "15px",
                margin: "20px 0",
              }}
            >
              <strong style={{}}>
                THE SOLE AND EXCLUSIVE PURPOSE OF KINSHIELD IS EDUCATIONAL.
              </strong>{" "}
              KinShield exists solely to educate users about the mechanisms,
              tactics, and techniques that scammers, fraudsters, and
              cybercriminals use so that users can better spot and avoid scams.
              KinShield's analyses, assessments, alerts, training materials,
              simulations, AI-generated content, and all other Service outputs
              are provided exclusively for educational and informational
              purposes. They are not intended to serve as, and should not be
              relied upon as, a definitive determination of whether any
              particular communication, transaction, or interaction is
              legitimate or fraudulent.
            </div>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              16.6 No Liability for User Decisions or Losses
            </h3>
            <div
              style={{
                backgroundColor: "#f8f8f8",
                border: "1px solid #ddd",
                padding: "15px",
                margin: "20px 0",
              }}
            >
              <strong style={{}}>
                YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT:
              </strong>
              <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
                <li>
                  Any advice, analysis, alert, recommendation, or educational
                  content provided by KinShield that may result in you still
                  falling victim to a scam, fraud, phishing attack, social
                  engineering scheme, identity theft, or any other form of
                  deception is <strong>NOT</strong> the responsibility of
                  KinShield, Reliable IT Associates, LLC, or any of its
                  officers, directors, employees, agents, contractors, or
                  affiliates, and they shall not be liable for any resulting
                  losses, damages, or harm.
                </li>
                <li>
                  KinShield shall not be liable for any financial losses,
                  identity theft, emotional distress, reputational harm, loss of
                  data, business interruption, or any other direct, indirect,
                  incidental, special, consequential, or punitive damages
                  arising from your reliance on or use of the Service, whether
                  or not KinShield was advised of the possibility of such
                  damages.
                </li>
                <li>
                  You assume all risk associated with your use of or reliance on
                  KinShield's AI-generated analyses and educational outputs, and
                  you agree that KinShield's role is limited to providing
                  educational tools and general awareness training.
                </li>
                <li>
                  KinShield does not guarantee, warrant, or represent that its
                  Service will prevent you from falling victim to any scam,
                  fraud, or cyberattack, regardless of the quality,
                  thoroughness, or frequency of use of the Service.
                </li>
                <li>
                  You are solely responsible for independently verifying the
                  legitimacy of any communication, transaction, offer, request,
                  or interaction, and for making your own informed decisions
                  based on your own judgment and, where appropriate,
                  consultation with qualified professionals.
                </li>
              </ul>
            </div>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="indemnification" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              17. Indemnification
            </h2>

            <p>
              You agree to indemnify, defend, and hold harmless Reliable IT
              Associates, LLC, its officers, directors, employees, agents,
              contractors, affiliates, licensors, and service providers
              (collectively, the "Indemnified Parties") from and against any and
              all claims, liabilities, damages, judgments, awards, losses,
              costs, expenses, and fees (including reasonable attorneys' fees)
              arising out of or relating to:
            </p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                Your violation of these Terms, the Privacy Policy, or the User
                Consent Agreement
              </li>
              <li>
                Your use of or reliance on the Service, including any
                AI-generated analyses, recommendations, or educational content
              </li>
              <li>
                Your failure to independently verify the legitimacy of any
                communication, transaction, or interaction
              </li>
              <li>
                Any content, data, or materials you submit, upload, or provide
                to the Service
              </li>
              <li>
                Your violation of any applicable law, regulation, or third-party
                rights
              </li>
              <li>
                Any financial loss, identity theft, or other harm you experience
                as a result of a scam, fraud, or cyberattack, regardless of
                whether you used KinShield's Service before, during, or after
                such incident
              </li>
              <li>
                Any dispute or claim brought by a third party arising from your
                use of the Service
              </li>
            </ul>
            <p>
              This indemnification obligation shall survive the termination or
              expiration of these Terms, your account, or your use of the
              Service.
            </p>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="eligibility" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              3. Eligibility and Account Requirements
            </h2>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              3.1 Age Requirements
            </h3>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>Individual accounts: Must be 16 years or older</li>
              <li>Family accounts: Account holder must be 18 years or older</li>
              <li>
                Organizational accounts: Must be established by authorized
                business representatives
              </li>
              <li>
                Users under 16 may participate only under direct parental
                supervision through family accounts
              </li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              3.2 Account Registration
            </h3>
            <p>To use KinShield, you must:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                Provide accurate, current, and complete information during
                registration
              </li>
              <li>Maintain and update your account information</li>
              <li>
                Protect your account credentials and notify us immediately of
                unauthorized access
              </li>
              <li>
                Accept responsibility for all activities under your account
              </li>
              <li>Comply with all applicable laws and regulations</li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              3.3 Account Types
            </h3>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                <strong>Individual:</strong> Single-user access to all training
                features
              </li>
              <li>
                <strong>Family:</strong> Up to 3 family members with parental
                controls and oversight
              </li>
              <li>
                <strong>Extended Family:</strong> Up to 6 family members with
                parental controls and oversight
              </li>
              <li>
                <strong>Organizational:</strong> Enterprise features including
                admin dashboards, reporting, and user management
              </li>
            </ul>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="service-description" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              4. Service Description and Availability
            </h2>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              4.1 Core Services
            </h3>
            <p>KinShield provides access to:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                Personalized cybersecurity training modules, quizzes, badges,
                and certificates
              </li>
              <li>
                AI-powered simulation exercises (phishing emails, SMS/text
                phishing, vishing, social engineering)
              </li>
              <li>
                Real-time performance tracking, risk scoring, and safety score
                analytics
              </li>
              <li>
                Educational content, resources, and AI-generated blog articles
              </li>
              <li>AI-powered email scam analysis and threat detection</li>
              <li>AI-powered SMS/text message scam analysis</li>
              <li>
                AI-powered image and screenshot analysis using computer vision
              </li>
              <li>AI-powered social media content scam analysis</li>
              <li>
                URL safety analysis using third-party threat intelligence
                databases
              </li>
              <li>
                Phone number scam verification and risk scoring using
                third-party validation services
              </li>
              <li>
                AI-powered Digital Personal Guard (DPG) chatbot for scam
                consultation
              </li>
              <li>
                Fraud detection pipeline with document analysis, OCR, and QR
                code detection
              </li>
              <li>
                PII (Personally Identifiable Information) detection and
                redaction
              </li>
              <li>Virus and malware scanning of uploaded files</li>
              <li>Real-time alerts, intelligence hub, and alert sharing</li>
              <li>Security reports, shield reports, and risk assessments</li>
              <li>Family/group management with role-based access control</li>
              <li>Real-time WebSocket push notifications</li>
              <li>Newsletter communications ("Cyber Sentinel")</li>
              <li>Progress tracking and adaptive learning features</li>
              <li>
                Browser fingerprinting for device identification and security
              </li>
              <li>Demo and event access features</li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              4.2 Service Availability
            </h3>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>We strive to maintain 99.5% uptime for our Service</li>
              <li>
                Scheduled maintenance will be announced in advance when possible
              </li>
              <li>
                Service may be temporarily unavailable due to maintenance,
                updates, or technical issues
              </li>
              <li>No guarantee of uninterrupted access is provided</li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              4.3 Service Modifications
            </h3>
            <p>We reserve the right to:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>Modify, update, or discontinue features of the Service</li>
              <li>Add new features or training modules</li>
              <li>
                Update simulation scenarios to reflect current cybersecurity
                threats
              </li>
              <li>
                Make changes necessary for security, legal compliance, or
                service improvement
              </li>
              <li>
                Provide notice of material changes when reasonably practicable
              </li>
            </ul>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="subscription" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              5. Subscription Terms and Billing
            </h2>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              5.1 Subscription Plans
            </h3>
            <p>KinShield offers various subscription tiers:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>Individual monthly/annual plans</li>
              <li>Family monthly/annual plans</li>
              <li>
                Business and Corporate (SMB) seat-based plans, priced by the
                number of licensed seats and billed to the organization
              </li>
              <li>Organizational custom pricing</li>
              <li>Free trial periods (where applicable)</li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              5.2 Billing and Payment
            </h3>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                Subscription fees are billed in advance on a recurring basis
              </li>
              <li>Payment is due immediately upon subscription activation</li>
              <li>All fees are non-refundable unless otherwise specified</li>
              <li>
                You authorize us to charge your payment method for all
                applicable fees
              </li>
              <li>Prices may change with 30 days' advance notice</li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              5.3 Auto-Renewal
            </h3>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                Subscriptions automatically renew unless cancelled before the
                renewal date
              </li>
              <li>You may cancel auto-renewal through your account settings</li>
              <li>
                Cancellation takes effect at the end of the current billing
                period
              </li>
              <li>
                No refunds are provided for unused portions of subscription
                periods
              </li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              5.4 Free Trials
            </h3>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                Free trials (where offered) are limited to one per
                user/organization
              </li>
              <li>
                Credit card information may be required for trial activation
              </li>
              <li>
                Trials automatically convert to paid subscriptions unless
                cancelled
              </li>
              <li>All Terms apply during trial periods</li>
            </ul>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="user-responsibilities" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              6. User Responsibilities and Acceptable Use
            </h2>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              6.1 Appropriate Use
            </h3>
            <p>
              You agree to use KinShield only for its intended educational
              purposes and will NOT:
            </p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                Use the Service for any illegal, harmful, or unauthorized
                purposes
              </li>
              <li>
                Attempt to circumvent, disable, or interfere with security
                features
              </li>
              <li>Share account credentials with unauthorized users</li>
              <li>
                Reverse engineer, decompile, or attempt to extract source code
              </li>
              <li>
                Use the Service to conduct actual phishing or social engineering
                attacks
              </li>
              <li>
                Misrepresent training simulations as real security threats
              </li>
              <li>
                Violate any applicable laws, regulations, or third-party rights
              </li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              6.2 Content and Conduct
            </h3>
            <p>You are responsible for:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>All content you submit or upload to the platform</li>
              <li>
                Ensuring compliance with your organization's policies (if
                applicable)
              </li>
              <li>Reporting any technical issues or security concerns</li>
              <li>Using training knowledge responsibly and ethically</li>
              <li>
                Maintaining confidentiality of proprietary training
                methodologies
              </li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              6.3 Prohibited Activities
            </h3>
            <p>The following activities are strictly prohibited:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>Harassment, abuse, or discrimination against other users</li>
              <li>
                Sharing or distributing malicious code or actual security
                threats
              </li>
              <li>
                Attempting to gain unauthorized access to other accounts or
                systems
              </li>
              <li>Commercial use of training content without authorization</li>
              <li>Interfering with the proper functioning of the Service</li>
            </ul>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="data-privacy" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              7. Data Privacy and Protection
            </h2>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              7.1 Data Collection and Use
            </h3>
            <p>
              We collect and process personal information to provide
              personalized cybersecurity training, including:
            </p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                Account registration information (name, email, phone, password)
              </li>
              <li>
                Training progress, quiz scores, badges, certificates, and
                performance data
              </li>
              <li>
                Email content, headers, metadata, and attachments submitted for
                scam analysis
              </li>
              <li>SMS/text message content submitted for scam analysis</li>
              <li>Images and screenshots uploaded for AI vision analysis</li>
              <li>Social media content submitted for scam analysis</li>
              <li>URLs submitted for safety analysis</li>
              <li>Phone numbers submitted for scam verification</li>
              <li>Documents, PDFs, and files submitted for fraud analysis</li>
              <li>
                Digital Personal Guard (DPG) chatbot conversation history and
                session data
              </li>
              <li>
                Browser fingerprint data (browser type, OS, device identifiers,
                screen resolution, canvas/WebGL/audio signatures, timezone,
                language)
              </li>
              <li>
                Usage analytics, interaction patterns, and feature usage data
              </li>
              <li>
                Communication preferences, notification settings, and feedback
              </li>
              <li>IP addresses, device information, and geolocation data</li>
              <li>Risk scores, safety scores, and vulnerability assessments</li>
              <li>
                Simulation performance metrics (emails opened, links clicked,
                response times)
              </li>
              <li>
                Payment and subscription information (processed by third-party
                payment processor)
              </li>
              <li>Consent records including timestamps and user agent data</li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              7.2 Data Protection Commitment
            </h3>
            <p>We are committed to protecting your privacy and implement:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                Industry-standard encryption for data transmission and storage
              </li>
              <li>
                Access controls limiting data access to authorized personnel
              </li>
              <li>Regular security audits and vulnerability assessments</li>
              <li>
                Compliance with applicable privacy regulations (GDPR, CCPA,
                etc.)
              </li>
              <li>
                Transparent data handling practices outlined in our Privacy
                Policy
              </li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              7.3 Data Retention and Deletion
            </h3>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                Personal data is retained only as long as necessary for service
                provision
              </li>
              <li>You may request data deletion upon account termination</li>
              <li>
                Training progress data may be retained for service improvement
                (anonymized)
              </li>
              <li>
                Legal compliance may require certain data retention periods
              </li>
              <li>
                Detailed retention policies are outlined in our Privacy Policy
              </li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              7.4 Third-Party Services
            </h3>
            <p>We may integrate with third-party services for:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>Payment processing (Stripe — encrypted and PCI-compliant)</li>
              <li>
                AI and machine learning analysis (Anthropic Claude, OpenAI)
              </li>
              <li>Email delivery and communications (SendGrid)</li>
              <li>SMS messaging and phone verification (Twilio)</li>
              <li>
                Cloud infrastructure, storage, and computing (Amazon Web
                Services)
              </li>
              <li>
                URL threat intelligence (Google Safe Browsing API, PhishTank)
              </li>
              <li>
                Phone number validation and risk scoring (IPQualityScore and
                other providers)
              </li>
              <li>PII detection and redaction (AWS Comprehend)</li>
              <li>Document OCR processing (AWS Textract)</li>
              <li>Virus and malware scanning (ClamAV)</li>
              <li>
                Browser fingerprinting and device identification (FingerprintJS)
              </li>
              <li>Analytics and performance monitoring</li>
              <li>Workflow automation (n8n for Digital Personal Guard)</li>
            </ul>
            <p>
              All third-party integrations comply with our privacy and security
              standards.
            </p>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="intellectual-property" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              8. Intellectual Property Rights
            </h2>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              8.1 Our Intellectual Property
            </h3>
            <p>
              KinShield and all related content, including but not limited to:
            </p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>Proprietary AI algorithms and training methodologies</li>
              <li>Training modules, simulations, and educational content</li>
              <li>Software, interfaces, and platform functionality</li>
              <li>Trademarks, logos, and branding materials</li>
              <li>Analytics and reporting tools</li>
            </ul>
            <p>
              Are owned by Reliable IT Associates, LLC and protected by
              intellectual property laws.
            </p>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              8.2 Limited License to Users
            </h3>
            <p>
              We grant you a limited, non-exclusive, non-transferable license
              to:
            </p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                Access and use the Service for its intended educational purposes
              </li>
              <li>
                Download and use training materials for personal/organizational
                training
              </li>
              <li>
                Generate and use reports for internal cybersecurity awareness
                purposes
              </li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              8.3 User Content
            </h3>
            <p>
              You retain ownership of content you create or upload, but grant
              us:
            </p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                A{" "}
                <strong>
                  non-exclusive, worldwide, royalty-free, perpetual, irrevocable
                  license
                </strong>{" "}
                to use, store, process, reproduce, analyze, and retain such
                content for the purposes of providing the Service, improving our
                products and services, conducting research, ensuring financial
                and legal compliance with applicable laws, and for any other
                legitimate business purpose
              </li>
              <li>
                Rights to anonymize, aggregate, and de-identify data derived
                from your content for service improvement, research, statistical
                analysis, fraud intelligence sharing, and industry reporting
              </li>
              <li>
                Permission to use feedback, suggestions, reviews, and ideas for
                platform enhancement without obligation or compensation to you
              </li>
              <li>
                The right to share anonymized and de-identified fraud
                intelligence derived from user-submitted content with law
                enforcement agencies, government entities, industry partners,
                and fraud prevention organizations for the purpose of combating
                fraud and protecting the public
              </li>
            </ul>
            <p>
              KinShield reserves a non-exclusive right to use and store the
              information users provide to KinShield for effective analysis,
              service delivery, service improvement, product development,
              training AI models, quality assurance, and financial and legal
              compliance with all applicable laws and regulations. This right
              survives the termination of your account or these Terms.
            </p>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              8.4 Restrictions
            </h3>
            <p>You may NOT:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>Copy, modify, or distribute our proprietary content</li>
              <li>Create derivative works based on our training materials</li>
              <li>
                Use our intellectual property for commercial purposes without
                authorization
              </li>
              <li>Remove or alter proprietary notices or attributions</li>
            </ul>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="account-termination" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              9. Account Termination
            </h2>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              9.1 Termination by User
            </h3>
            <p>You may terminate your account at any time by:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>Cancelling your subscription through account settings</li>
              <li>Contacting our customer support team</li>
              <li>
                Following cancellation procedures outlined in the platform
              </li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              9.2 Termination by Company
            </h3>
            <p>We may suspend or terminate your account if you:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>Violate these Terms or our Acceptable Use Policy</li>
              <li>Engage in fraudulent or illegal activities</li>
              <li>Pose a security risk to our platform or other users</li>
              <li>Fail to pay applicable subscription fees</li>
              <li>Misuse the Service in ways that could harm others</li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              9.3 Effect of Termination
            </h3>
            <p>Upon account termination:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>Access to the Service will be immediately discontinued</li>
              <li>
                Your data will be handled according to our data retention
                policies
              </li>
              <li>
                No refunds will be provided for unused subscription periods
              </li>
              <li>
                Certain provisions of these Terms will survive termination
              </li>
              <li>You must cease all use of our intellectual property</li>
            </ul>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="disclaimers" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              10. Disclaimers and Limitations of Liability
            </h2>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              10.1 Service Disclaimers
            </h3>
            <div
              style={{
                backgroundColor: "#f8f8f8",
                border: "1px solid #ddd",

                padding: "15px",
                margin: "20px 0",
              }}
            >
              <strong style={{}}>IMPORTANT DISCLAIMERS:</strong>
              <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
                <li>
                  KinShield is provided "AS IS" and "AS AVAILABLE" without
                  warranties of any kind, whether express, implied, statutory,
                  or otherwise, including but not limited to implied warranties
                  of merchantability, fitness for a particular purpose,
                  non-infringement, accuracy, reliability, or completeness
                </li>
                <li>
                  We do not guarantee that training or analysis will prevent all
                  cybersecurity incidents, scams, fraud, or financial losses
                </li>
                <li>
                  KinShield uses AI technology that is inherently imperfect, may
                  produce errors, may use outdated information, and may fail to
                  detect scams or fraud
                </li>
                <li>
                  The cybersecurity and scam landscape evolves rapidly; our
                  Service content may not cover all possible threats or the
                  latest attack vectors
                </li>
                <li>
                  We are not responsible for any cybersecurity incidents,
                  financial losses, identity theft, or other harm that occurs
                  despite use of the Service
                </li>
                <li>
                  KinShield is not a law enforcement agency, does not provide
                  legal, financial, or personal advice, and is solely an
                  educational tool
                </li>
                <li>
                  Any guidance, analysis, or recommendation provided by
                  KinShield, whether generated by AI or otherwise, that results
                  in a user still falling victim to a scam or fraud is not
                  KinShield's responsibility, and KinShield shall not be liable
                  for any resulting damages
                </li>
                <li>
                  We make no warranties regarding the accuracy, completeness,
                  timeliness, or reliability of any AI-generated analysis,
                  content, or recommendation
                </li>
                <li>
                  We do not warrant that the Service will be uninterrupted,
                  secure, or error-free
                </li>
              </ul>
            </div>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              10.2 Educational Limitations
            </h3>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                Training effectiveness varies by individual and organizational
                factors
              </li>
              <li>
                Completion of training does not guarantee immunity from cyber
                threats
              </li>
              <li>
                Real-world cybersecurity requires ongoing vigilance beyond our
                training
              </li>
              <li>
                Some threats may not be covered in our current training modules
              </li>
              <li>
                Training should supplement, not replace, comprehensive
                cybersecurity measures
              </li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              10.3 Limitation of Liability
            </h3>
            <div
              style={{
                backgroundColor: "#f8f8f8",
                border: "1px solid #ddd",

                padding: "15px",
                margin: "20px 0",
              }}
            >
              <strong style={{}}>
                TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW:
              </strong>
              <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
                <li>
                  Our total aggregate liability for any and all claims related
                  to the Service is limited to the lesser of (a) the amount you
                  actually paid for the Service in the 12 months preceding the
                  claim, or (b) one hundred dollars ($100.00 USD)
                </li>
                <li>
                  We are not liable for any indirect, incidental, special,
                  consequential, exemplary, or punitive damages, including but
                  not limited to loss of profits, revenue, data, business
                  opportunities, goodwill, or anticipated savings
                </li>
                <li>
                  We are not responsible for any damages, losses, or harm
                  resulting from cybersecurity incidents, scams, fraud, identity
                  theft, or financial losses, regardless of whether you used the
                  Service, followed its recommendations, or relied on its
                  AI-generated analyses
                </li>
                <li>
                  We are not liable for any actions you take or fail to take
                  based on AI-generated analyses, recommendations, alerts, or
                  educational content provided through the Service
                </li>
                <li>
                  Liability limitations apply regardless of the legal theory of
                  the claim, including but not limited to breach of contract,
                  tort (including negligence), strict liability, or any other
                  theory
                </li>
                <li>
                  Some jurisdictions may not allow certain liability
                  limitations; in such jurisdictions, our liability shall be
                  limited to the maximum extent permitted by law
                </li>
                <li>
                  The foregoing limitations shall apply even if a remedy fails
                  of its essential purpose and even if KinShield has been
                  advised of the possibility of such damages
                </li>
              </ul>
            </div>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              10.4 Force Majeure
            </h3>
            <p>
              We are not liable for delays or failures in performance caused by
              circumstances beyond our reasonable control, including but not
              limited to natural disasters, government actions, network
              failures, or other force majeure events.
            </p>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="privacy-compliance" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              11. Privacy and Compliance
            </h2>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              11.1 Privacy Policy
            </h3>
            <p>
              Our collection, use, and protection of personal information is
              governed by our Privacy Policy, which is incorporated into these
              Terms by reference. Please review our Privacy Policy to understand
              our data practices.
            </p>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              11.2 Regulatory Compliance
            </h3>
            <p>We strive to comply with applicable regulations, including:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>General Data Protection Regulation (GDPR)</li>
              <li>California Consumer Privacy Act (CCPA)</li>
              <li>Children's Online Privacy Protection Act (COPPA)</li>
              <li>Relevant cybersecurity and data protection regulations</li>
              <li>
                Industry-specific compliance requirements (where applicable)
              </li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              11.3 International Users
            </h3>
            <p>If you access KinShield from outside the United States:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                You consent to the transfer of your data to the United States
              </li>
              <li>
                Local laws and regulations may apply to your use of the Service
              </li>
              <li>
                You are responsible for compliance with applicable local laws
              </li>
              <li>These Terms are governed by United States law</li>
            </ul>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="dispute-resolution" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              12. Dispute Resolution and Governing Law
            </h2>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              12.1 Governing Law
            </h3>
            <p>
              These Terms are governed by the laws of the State of Maryland,
              United States, without regard to conflict of law principles.
            </p>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              12.2 Dispute Resolution Process
            </h3>
            <p>
              For any disputes arising from these Terms or your use of the
              Service:
            </p>

            <h4
              style={{
                marginTop: "25px",
                marginBottom: "10px",
              }}
            >
              Step 1: Direct Resolution
            </h4>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>Contact our support team to attempt resolution</li>
              <li>Provide detailed description of the dispute</li>
              <li>Allow 30 days for good-faith resolution efforts</li>
            </ul>

            <h4
              style={{
                marginTop: "25px",
                marginBottom: "10px",
              }}
            >
              Step 2: Mediation
            </h4>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                If direct resolution fails, disputes will be resolved through
                binding mediation
              </li>
              <li>
                Mediation will be conducted by a mutually agreed-upon mediator
              </li>
              <li>Mediation costs will be shared equally between parties</li>
              <li>
                Mediation will take place in the State of Maryland or via video
                conference
              </li>
            </ul>

            <h4
              style={{
                marginTop: "25px",
                marginBottom: "10px",
              }}
            >
              Step 3: Arbitration
            </h4>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                If mediation fails, disputes will be resolved through binding
                arbitration
              </li>
              <li>
                Arbitration will be conducted under the rules of the American
                Arbitration Association
              </li>
              <li>Arbitration will be conducted by a single arbitrator</li>
              <li>Arbitrator's decision will be final and binding</li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              12.3 Class Action Waiver
            </h3>
            <p>
              You agree that disputes will be resolved individually and waive
              any right to participate in class action lawsuits or class-wide
              arbitration.
            </p>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              12.4 Exceptions
            </h3>
            <p>
              The following disputes are exempt from the above resolution
              process:
            </p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>Claims involving intellectual property rights</li>
              <li>Claims seeking injunctive relief</li>
              <li>
                Small claims court actions (under applicable monetary limits)
              </li>
            </ul>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="general-provisions" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              13. General Provisions
            </h2>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              13.1 Entire Agreement
            </h3>
            <p>
              These Terms, together with our Privacy Policy and any additional
              agreements you enter into with us, constitute the entire agreement
              between you and Reliable IT Associates, LLC regarding the Service.
            </p>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              13.2 Modifications to Terms
            </h3>
            <p>We may modify these Terms at any time by:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                Posting updated Terms on our website with a new effective date
              </li>
              <li>
                Providing notice of material changes via email or platform
                notification
              </li>
              <li>
                Continuing to use the Service after modifications constitutes
                acceptance
              </li>
              <li>
                If you disagree with modifications, you may terminate your
                account
              </li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              13.3 Severability
            </h3>
            <p>
              If any provision of these Terms is found to be unenforceable, the
              remaining provisions will remain in full force and effect.
            </p>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              13.4 Waiver
            </h3>
            <p>
              Our failure to enforce any provision of these Terms does not
              constitute a waiver of that provision or any other provision.
            </p>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              13.5 Assignment
            </h3>
            <p>
              You may not assign or transfer your rights under these Terms
              without our prior written consent. We may assign these Terms
              without restriction.
            </p>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              13.6 Survival
            </h3>
            <p>The following provisions survive termination of these Terms:</p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>Intellectual Property Rights</li>
              <li>Disclaimers and Limitations of Liability</li>
              <li>Dispute Resolution</li>
              <li>General Provisions</li>
            </ul>

            <h3
              style={{
                marginTop: "30px",
                marginBottom: "15px",
              }}
            >
              13.7 Contact Information
            </h3>
            <div
              style={{
                backgroundColor: "#f8f8f8",
                border: "1px solid #ddd",

                padding: "20px",
                margin: "20px 0",
                textAlign: "center",
              }}
            >
              <p>
                For questions about these Terms or the Service, contact us at:
              </p>
              <p>
                <strong style={{ fontSize: "1.1em" }}>
                  Reliable IT Associates, LLC
                </strong>
                <br />
                Email: info@kinprotect.com
                <br />
                Headquarters: Maryland, USA
                <br />
                Phone: 301-237-7843
              </p>
            </div>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="acknowledgment" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              14. Acknowledgment and Acceptance
            </h2>

            <div
              style={{
                backgroundColor: "#f8f8f8",
                border: "1px solid #ddd",

                padding: "20px",
                margin: "30px 0",
              }}
            >
              <p>By using KinShield, you acknowledge that:</p>
              <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
                <li>
                  You have read and understood these Terms in their entirety
                </li>
                <li>
                  You agree to be bound by these Terms, our Privacy Policy, and
                  our User Consent Agreement
                </li>
                <li>
                  You understand that KinShield uses artificial intelligence
                  (AI) technology to analyze artifacts and provide educational
                  content, and that AI can make mistakes, use outdated
                  information, produce inaccurate results, and fail to detect
                  scams or fraud
                </li>
                <li>
                  You understand that KinShield is NOT a law enforcement agency
                  and does NOT provide legal, financial, personal, medical, or
                  professional advice of any kind
                </li>
                <li>
                  You understand that KinShield's sole purpose is to educate
                  users about scam mechanisms and tactics to help users spot and
                  avoid scams
                </li>
                <li>
                  You understand that if you still fall victim to a scam despite
                  using KinShield's Service, KinShield is not responsible and
                  shall not be liable for any resulting losses or damages
                </li>
                <li>
                  You understand that KinShield reserves a non-exclusive right
                  to use and store information you provide for effective
                  analysis, service improvement, and financial and legal
                  compliance with applicable laws
                </li>
                <li>
                  You will use the Service responsibly and in compliance with
                  all applicable laws
                </li>
                <li>
                  You consent to our data collection, AI processing, and data
                  sharing practices as outlined in our Privacy Policy
                </li>
                <li>
                  You agree to indemnify KinShield against any claims arising
                  from your use of or reliance on the Service
                </li>
              </ul>
              <p>
                <strong>
                  These Terms are effective as of the date first written above
                  and will remain in effect until terminated in accordance with
                  the provisions herein.
                </strong>
              </p>
            </div>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="corporate-accounts" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              18. Corporate and Organizational Accounts
            </h2>

            <p>
              This Section 18 applies in addition to the rest of these Terms
              when you register for, administer, or are enrolled in a business,
              corporate, or other organizational account ("Corporate Account"),
              including our small-and-medium-business (SMB) and Corporate
              edition plans. In the event of a conflict between this Section and
              any other provision of these Terms with respect to a Corporate
              Account, this Section controls; in the event of a conflict between
              these Terms and a separately executed business or enterprise
              agreement, that agreement controls.
            </p>

            <h3 style={{ marginTop: "30px", marginBottom: "15px" }}>
              18.1 Authority to Bind the Organization
            </h3>
            <p>
              If you create or administer a Corporate Account on behalf of a
              company or other organization (the "Customer"), you represent and
              warrant that you are authorized to bind the Customer to these
              Terms. These Terms are then a binding agreement between Reliable
              IT Associates, LLC and the Customer, and references to "you"
              include the Customer.
            </p>

            <h3 style={{ marginTop: "30px", marginBottom: "15px" }}>
              18.2 Account Administration and Seats
            </h3>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                The Customer designates an account owner and may designate
                account and group administrators to manage the Corporate Account
              </li>
              <li>
                Access is licensed on a per-seat basis; the Customer is
                responsible for ensuring the number of active members does not
                exceed its licensed seats and for any applicable seat overage or
                true-up charges
              </li>
              <li>
                The Customer is responsible for inviting, provisioning,
                managing, and promptly offboarding its members and for all
                activity that occurs under its Corporate Account
              </li>
              <li>
                Administrators may assign training and simulation campaigns and
                access member profiles, completion and compliance status, risk
                and safety scores, and team-level analytics
              </li>
            </ul>

            <h3 style={{ marginTop: "30px", marginBottom: "15px" }}>
              18.3 Member Data, Notice, and Consent
            </h3>
            <p>
              The Customer is the controller of its members' personal
              information and KinShield acts as a processor/service provider on
              the Customer's behalf, as further described in our Privacy Policy
              and any Data Processing Agreement. The Customer represents and
              warrants that it will:
            </p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                Establish a valid legal basis for collecting and processing
                member personal information through the Service
              </li>
              <li>
                Provide its members with all legally required privacy notices
                and obtain any consents required by applicable law, including
                for phishing and social-engineering simulations and security
                awareness monitoring
              </li>
              <li>
                Comply with all applicable employment, workplace-monitoring,
                privacy, and data protection laws in the jurisdictions where its
                members reside
              </li>
              <li>
                Only submit member or third-party data that it is authorized to
                provide to KinShield
              </li>
            </ul>

            <h3 style={{ marginTop: "30px", marginBottom: "15px" }}>
              18.4 Billing and Payment for Corporate Accounts
            </h3>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                Seat-based fees are billed in advance to the Customer on a
                recurring basis and are non-refundable except as required by law
                or expressly stated in writing
              </li>
              <li>
                The Customer authorizes KinShield (and its payment processor,
                Stripe) to charge the Customer's payment method for all
                applicable seat, overage, and renewal fees
              </li>
              <li>
                Corporate plans automatically renew unless cancelled before the
                renewal date through the account settings or as otherwise agreed
              </li>
              <li>
                Custom or enterprise pricing, invoicing terms, and order forms,
                where applicable, are governed by a separately executed
                agreement
              </li>
            </ul>

            <h3 style={{ marginTop: "30px", marginBottom: "15px" }}>
              18.5 Acceptable Use Within the Organization
            </h3>
            <p>
              The Customer is responsible for ensuring that its administrators
              and members use the Service in compliance with these Terms, the
              Customer's own policies, and all applicable laws. Simulations and
              training are provided strictly for the Customer's internal
              security awareness and education and may not be used to conduct
              actual phishing, social engineering, or attacks against any
              individual or system without authorization.
            </p>

            <h3 style={{ marginTop: "30px", marginBottom: "15px" }}>
              18.6 Data Processing Agreement
            </h3>
            <p>
              Upon request, KinShield will make available a Data Processing
              Agreement ("DPA") governing its processing of member personal
              information on the Customer's behalf, including, where applicable,
              Standard Contractual Clauses and equivalent transfer mechanisms
              for international data transfers and a list of sub-processors. The
              DPA, once executed, is incorporated into and forms part of these
              Terms.
            </p>

            <h3 style={{ marginTop: "30px", marginBottom: "15px" }}>
              18.7 Confidentiality
            </h3>
            <p>
              Each party will protect the other's non-public information
              disclosed in connection with the Corporate Account using
              reasonable care and will use it only as necessary to perform under
              these Terms, except as required by law.
            </p>

            <h3 style={{ marginTop: "30px", marginBottom: "15px" }}>
              18.8 Corporate Indemnification
            </h3>
            <p>
              In addition to the indemnification obligations in Section 17, the
              Customer agrees to indemnify, defend, and hold harmless the
              Indemnified Parties from and against any claims, liabilities,
              damages, losses, costs, and expenses (including reasonable
              attorneys' fees) arising out of or relating to: (a) the Customer's
              failure to obtain required member notices or consents or to
              establish a valid legal basis for processing; (b) the Customer's
              violation of any employment, workplace-monitoring, privacy, or
              data protection law; (c) any dispute between the Customer and its
              members, administrators, or personnel; (d) the Customer's
              configuration, administration, or use of the Corporate Account; or
              (e) any content submitted to the Service by the Customer or its
              members (including emails, messages, documents, images, and other
              materials forwarded or uploaded for analysis) in violation of
              Section 19, including content the submitter was not authorized to
              disclose or that contains third-party, regulated, privileged, or
              confidential information.
            </p>

            <h3 style={{ marginTop: "30px", marginBottom: "15px" }}>
              18.9 Suspension, Termination, and Offboarding
            </h3>
            <p>
              Upon termination or expiration of a Corporate Account, member
              access will be deactivated and, subject to KinShield's legal and
              financial retention obligations, member personal information
              processed on the Customer's behalf will be returned or deleted at
              the Customer's request in accordance with the applicable DPA. The
              Customer remains responsible for exporting any data it wishes to
              retain prior to termination.
            </p>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section id="submitted-content" style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              19. User-Submitted Content, Warranties, and Prohibited Content
            </h2>

            <p>
              The Service allows you to submit content for analysis, including
              by forwarding or uploading emails, text/SMS messages, social media
              content, images, screenshots, documents, files, URLs, and phone
              numbers ("Submitted Content"). To provide the Service, Submitted
              Content is processed by KinShield and transmitted to third-party
              artificial intelligence and analysis providers as described in
              Section 7 (Data Privacy and Protection) and our Privacy Policy.
              This Section 19 applies to all users, including members of
              Corporate Accounts.
            </p>

            <div
              style={{
                backgroundColor: "#f8f8f8",
                border: "1px solid #ddd",
                padding: "15px",
                margin: "20px 0",
              }}
            >
              <strong>
                Only submit content that you are authorized to share and that is
                appropriate for analysis by an automated, AI-assisted service.
                Do not submit content you are not permitted to disclose to a
                third-party service provider.
              </strong>
            </div>

            <h3 style={{ marginTop: "30px", marginBottom: "15px" }}>
              19.1 Your Representations and Warranties
            </h3>
            <p>
              By submitting any Submitted Content, you represent and warrant
              that:
            </p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                You have all rights, authority, licenses, permissions, and
                consents necessary to submit the content and to allow KinShield
                and its AI and analysis sub-processors to process it for the
                purposes described in these Terms and our Privacy Policy
              </li>
              <li>
                Your submission of the content does not and will not violate any
                law, contract, confidentiality or nondisclosure obligation,
                intellectual property right, privacy right, attorney-client
                privilege, work-product protection, or any policy of your
                employer or organization
              </li>
              <li>
                If the content contains personal information of any third party,
                you (or, for Corporate Accounts, the Customer as controller)
                have provided all required notices and obtained all consents or
                established another valid legal basis required by applicable law
              </li>
              <li>
                You are solely responsible for the content you submit and for
                ensuring it does not include material that is prohibited under
                Section 19.2
              </li>
            </ul>

            <h3 style={{ marginTop: "30px", marginBottom: "15px" }}>
              19.2 Prohibited Content
            </h3>
            <p>
              Unless you have entered into a separate written agreement with
              Reliable IT Associates, LLC that expressly permits such use (for
              example, a Business Associate Agreement for protected health
              information), you must NOT submit to the Service any:
            </p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                Protected health information (PHI) or other data subject to the
                Health Insurance Portability and Accountability Act (HIPAA)
              </li>
              <li>
                Payment card data subject to the Payment Card Industry Data
                Security Standard (PCI-DSS), such as full primary account
                numbers, beyond what is necessary to report a scam
              </li>
              <li>
                Nonpublic personal financial information subject to the
                Gramm-Leach-Bliley Act (GLBA)
              </li>
              <li>
                Student education records subject to the Family Educational
                Rights and Privacy Act (FERPA)
              </li>
              <li>
                Criminal justice information (CJIS), classified, government
                restricted, or export-controlled data (including ITAR/EAR
                controlled technical data)
              </li>
              <li>
                Special categories of personal data (such as data revealing
                racial or ethnic origin, political opinions, religious beliefs,
                health, genetic or biometric data, or sexual orientation) except
                to the extent inherent in a scam artifact you are reporting
              </li>
              <li>
                Attorney-client privileged communications, attorney work
                product, or other legally privileged material
              </li>
              <li>
                Trade secrets or confidential or proprietary information that
                you are not authorized to disclose to a third-party service
                provider and its sub-processors
              </li>
            </ul>
            <p>
              You acknowledge that KinShield applies automated detection and
              redaction of certain personal information before AI processing,
              but that such measures are not guaranteed to detect or remove all
              sensitive, regulated, or prohibited content, and do not relieve
              you of your obligations under this Section 19.
            </p>

            <h3 style={{ marginTop: "30px", marginBottom: "15px" }}>
              19.3 License to Submitted Content
            </h3>
            <p>
              As between you and KinShield, you (or your organization) retain
              all ownership rights in your Submitted Content. You grant Reliable
              IT Associates, LLC a limited, non-exclusive, worldwide,
              royalty-free license to host, store, process, transmit, and
              analyze the Submitted Content, and to share it with the AI and
              analysis sub-processors described in our Privacy Policy, solely to
              provide, secure, and improve the Service and to comply with law.
              We may also create and retain anonymized, de-identified, and
              aggregated data and fraud intelligence derived from Submitted
              Content as described in our Privacy Policy.
            </p>

            <h3 style={{ marginTop: "30px", marginBottom: "15px" }}>
              19.4 AI and Analysis Sub-Processors
            </h3>
            <p>
              Submitted Content is transmitted to third-party AI providers
              (including Anthropic and OpenAI) and other analysis providers for
              processing. Under our agreements with these providers, Submitted
              Content is treated as confidential and is not used to train their
              models, and international transfers are governed by appropriate
              safeguards such as Standard Contractual Clauses. A current list of
              sub-processors is available on request and, for Corporate
              Accounts, through the Data Processing Agreement described in
              Section 18.6.
            </p>

            <h3 style={{ marginTop: "30px", marginBottom: "15px" }}>
              19.5 Enforcement
            </h3>
            <p>
              We may, but are not obligated to, monitor, filter, refuse, redact,
              or remove Submitted Content, and may suspend or terminate accounts
              that violate this Section 19. Your indemnification obligations in
              Section 17 (and, for Corporate Accounts, Section 18.8) apply to
              any breach of this Section 19.
            </p>
          </section>

          <div
            style={{
              textAlign: "center",
              fontStyle: "italic",
              color: "#666",
              marginTop: "30px",
              paddingTop: "20px",
              borderTop: "1px solid #ddd",
            }}
          >
            <p>
              <em>
                This document was last updated on June 26, 2026. We recommend
                reviewing these Terms periodically for any updates or changes.
              </em>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
